import {useQuery} from '@tanstack/react-query';
import {useAccountsRepository} from './rest';
import {useAuth} from '~/auth/AuthContext';

const personalAccountKey = 'personal-account';

export const usePersonalAccount = () => {
  const {user: authUser} = useAuth();
  const {getPersonalAccount} = useAccountsRepository();

  const isEmailAvailable = authUser && Boolean(authUser?.email);

  return useQuery({
    queryKey: [personalAccountKey, authUser?.email],
    queryFn: async () => {
      if (!isEmailAvailable) {
        return null;
      }
      return getPersonalAccount(authUser.email);
    },
    staleTime: 10000,
    enabled: isEmailAvailable
  });
};
